// extracted by mini-css-extract-plugin
export default {"line":"ProjectSeparator-module--line--e7897","triangle":"ProjectSeparator-module--triangle--0a21e"};